import React, { useEffect } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../../types/constants';
import { useContentstackPage } from '../../../hooks/useContentstack';
import { CmsFeature } from '../../../types/contentstack';
import { ContactFeatureCards } from '../../../components/ContactFeatureCards/ContactFeatureCards';

interface FeatureSection {
  name: string;
  features: CmsFeature[];
}

const ContactUs: React.FC = () => {
  const { t } = useTranslation();
  const { data: pageData, loading } = useContentstackPage('contact-us');

  useEffect(() => {
    document.title = t(TranslationKeyEnum.ContactUs);
  }, [t]);

  const featureSection = pageData?.components?.[0]
    ? ((pageData.components[0] as Record<string, unknown>).feature_section as FeatureSection)
    : null;

  return (
    <div className="flex max-w-[627px] w-full flex-col gap-4">
      <div className="flex flex-col gap-2">
        <h2 className="text-detail-150 font-bold text-black/90">
          {pageData?.title ?? t(TranslationKeyEnum.ContactUs)}
        </h2>
        {featureSection?.name && (
          <p className="text-detail-100 font-medium text-black/90">{featureSection.name}</p>
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <ContactFeatureCards features={featureSection?.features ?? []} />
      )}
    </div>
  );
};

export default ContactUs;
